// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as BlacklistPartnerResponseApiModel from "../api-model/BlacklistPartnerResponseApiModel.bs.js";

function apiModelToEntity(apiModel) {
  return {
          message: apiModel.message,
          success: apiModel.success
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(BlacklistPartnerResponseApiModel.t_decode(json), "BlacklistPartnerResponseMapper.res"));
}

export {
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
